export default "__VITE_ASSET__DFqV1CSq__"